import React from "react";

interface BlogPostSocialLinksProps {
  post: {
    facebook_url?: string;
    twitter_url?: string;
    instagram_url?: string;
    linkedin_url?: string;
    youtube_url?: string;
    tiktok_url?: string;
    threads_url?: string;
    google_business_url?: string;
    pinterest_url?: string;
    snapchat_url?: string;
    bluesky_url?: string;
    reddit_url?: string;
    substack_url?: string;
    discord_url?: string;
  };
  getSocialIcon: (platform: string) => string | React.ComponentType<{ className?: string }> | null;
  iconClassName?: string;
}

const SOCIAL_PLATFORMS = [
  "facebook",
  "twitter",
  "instagram",
  "linkedin",
  "youtube",
  "tiktok",
  "threads",
  "google_business",
  "pinterest",
  "snapchat",
  "bluesky",
  "reddit",
  "substack",
  "discord",
];

const BlogPostSocialLinks = ({ post, getSocialIcon, iconClassName = "w-3.5 h-3.5" }: BlogPostSocialLinksProps) => {
  const socialLinks = SOCIAL_PLATFORMS
    .map((platform) => {
      const url = post[`${platform}_url` as keyof typeof post] as string | undefined;
      const iconData = getSocialIcon(platform);
      if (url && iconData) {
        return { platform, url, iconData };
      }
      return null;
    })
    .filter(Boolean) as Array<{ platform: string; url: string; iconData: string | React.ComponentType<{ className?: string }> }>;

  if (socialLinks.length === 0) {
    return null;
  }

  return (
    <div className="flex gap-2 mt-2">
      {socialLinks.map((link) => {
        const IconComponent = typeof link.iconData !== "string" ? link.iconData : null;
        return (
          <a
            key={link.platform}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="p-1.5 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors flex-shrink-0"
            aria-label={`Visit us on ${link.platform.charAt(0).toUpperCase() + link.platform.slice(1).replace("_", " ")}`}
          >
            {typeof link.iconData === "string" ? (
              <img src={link.iconData} alt={link.platform} className={`${iconClassName} object-contain`} />
            ) : IconComponent ? (
              <IconComponent className={iconClassName} />
            ) : null}
          </a>
        );
      })}
    </div>
  );
};

export default BlogPostSocialLinks;
